// API Status
export const API_LOADING = 'API_LOADING';
export const API_SUCCESS = 'API_SUCCESS';
export const API_FAILURE = 'API_FAILURE';

// API Service Group : Login
export const API_INIT = 'API_INIT';
export const API_LOGIN = 'API_LOGIN';

// API Service Group : Users
export const API_GET_USERS = 'API_GET_USERS';

// Dashboard
export const TOGGLE_HELLO = 'TOGGLE_HELLO';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js